import axios from "axios";
import { BASE_URL } from "./settings";

const URLS = {
  SUB: BASE_URL + "SubModulo",
};

export default class SubModulosService {
  static getSubModulos = async (id) => {

    let url = URLS.SUB + "?moduloId=" + id;
    //temporario, para seguir com desenvolvimento  
    try {
      let { data } = await axios.get(url);          
      return data;
    } catch (err) {
      return err;
    }
  };
}
